import { render, staticRenderFns } from "./delivery-data.vue?vue&type=template&id=8393da9c&scoped=true&"
import script from "./delivery-data.vue?vue&type=script&lang=js&"
export * from "./delivery-data.vue?vue&type=script&lang=js&"
import style0 from "./delivery-data.vue?vue&type=style&index=0&id=8393da9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8393da9c",
  null
  
)

component.options.__file = "delivery-data.vue"
export default component.exports